














import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'ui-file-input',
})
export default class UiFileInputComponent extends Vue {
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: true }) showError!: boolean;
  @Prop({ default: 5 }) maxSizeMb: number;
  @Prop({ default: '' }) label!: string;
  @Prop({ default: true }) showFileName!: boolean;

  private file: File;
  get maxSizeBytes(): number {
    return this.maxSizeMb * 1024 * 1024;
  }
  getFile(): File {
    if (!this.$refs.file) return null;
    var files = (this.$refs.file as HTMLInputElement).files;
    return files[0];
  }
  private clearValue() {
    (this.$refs.file as HTMLInputElement).value = null;
  }
  setFile(file?: File) {
    this.file = file;
    this.fileName = !!file ? file.name : this.noImageText;
  }

  private noImageText = '';
  fileName: string = this.noImageText;
  focused = false;
  hasError: boolean = false;
  errorMessage: string = '';

  id = `ui_file_input_${Math.floor(Math.random() * 1000) + 1}`;
  showClick() {
    //this.$refs.inputEl.click();
  }
  onClick() {
    (this.$refs.file as HTMLElement).click();
  }
  onChangeInput() {
    var file = this.getFile();
    if (file.size > this.maxSizeBytes) {
      this.setFile();
      this.errorMessage = 'Размер файла большой!';
      console.error(`Maximum file size ${this.maxSizeMb} Mb`);
      this.$notification.error(`${this.$locale.getTranslate('Maximum file size')}:${this.maxSizeMb} Mb`, this.$locale.getTranslate('Error'));
      return;
    }
    this.fileName = file.name;
    this.$forceUpdate();
    this.$emit('onChange', file);
    this.clearValue();
  }
  isValid(): boolean {
    var isValid = !this.required || !!this.file;
    this.errorMessage = isValid ? '' : 'Файл обязателен';
    return isValid;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/components/ui-file-input.vue